import { render, staticRenderFns } from "./listTingbox.vue?vue&type=template&id=77ec198b&scoped=true"
import script from "./listTingbox.vue?vue&type=script&lang=js"
export * from "./listTingbox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77ec198b",
  null
  
)

export default component.exports